<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="选择时间"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="date-tab-box">
      <div
        v-for="(item,index) in tabs"
        :key="index"
        @click="changeIndex(index)"
        :class="selectIndex==index?'item active':'item'"
      >{{item}}</div>
    </div>

    <div class="date-range-box">
      <div class="tit">自定义时间</div>
      <div class="date-range-select">
        <van-field
          v-model="startDate"
          placeholder="开始时间"
          input-align="center"
          readonly
          :border="false"
          class="date-field"
          @click="startDateShow = true;"
        />
        <span class="contact-word">至</span>
        <van-field
          v-model="endDate"
          placeholder="结束时间"
          input-align="center"
          readonly
          :border="false"
          class="date-field"
          @click="endDateShow = true;"
        />
      </div>
      <div class="delete-box">
        <van-icon name="delete" size="21" color="#777" />
      </div>
      <div class="button-area">
        <van-button round type="default" @click="onClickLeft">取消</van-button>
        <van-button round color="gold" @click="onSearch">确定</van-button>
      </div>
    </div>

    <!-- 开始时间 popup start -->
    <van-popup v-model="startDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择开始时间"
        v-model="currenDate"
        type="date"
        :max-date="maxDate"
        @confirm="startDateConfirm"
        @cancel="startDateShow = false"
      />
    </van-popup>
    <!-- 开始时间 popup end -->
    <!-- 结束时间 popup start -->
    <van-popup v-model="endDateShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        title="选择结束时间"
        v-model="currenEndDate"
        type="date"
        :max-date="maxDate"
        @confirm="endDateConfirm"
        @cancel="endDateShow = false"
      />
    </van-popup>
    <!-- 结束时间 popup end -->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { DateAdd, FormatDate } from "../../../tools/date";
export default {
  data() {
    return {
      tabs: ["全部", "今日", "昨日", "本月", "上月"],
      currenDate: new Date(),
      currenEndDate: new Date(),
      maxDate: new Date(),
      startDateShow: false,
      startDate: "",
      endDateShow: false,
      endDate: "",
      selectIndex: 0,
      input: {
        startTime:"",
        endTime:"",
        timeType: 0
      }
    };
  },
  components: {},
   computed: {
    ...mapState({
      queryInput: state => state.transactionDetail.queryInput
    })
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");

    DateAdd("m", -3, this.currenDate);
    if(this.queryInput!=null){
        console.log("run");
          this.input=JSON.parse(this.queryInput);
          this.selectIndex=this.input.timeType;
          if(this.input.startTime!=""&&this.input.endTime!="")
          {
            this.startDate=this.input.startTime;
            this.endDate=this.input.endTime;
            this.currenDate=new Date(this.input.startTime);
            this.currenEndDate=new Date(this.input.endTime);
          }
    }

  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    startDateChange(picker, value, index) {
      console.log(picker.getValues());
      console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.startDate =
        dateArray[0].replace("年", "") +
        "/" +
        dateArray[1].replace("月", "") +
        "/" +
        dateArray[2].replace("日", "");
    },
    endDateChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
      let dateArray = picker.getValues();
      this.endDate =
        dateArray[0].replace("年", "") +
        "/" +
        dateArray[1].replace("月", "") +
        "/" +
        dateArray[2].replace("日", "");
    },
    startDateConfirm(val) {
      this.startDateShow = false;
      this.startDate = FormatDate(val.getTime(), "YY/MM/DD");
      this.input.startTime =this.startDate;
    },
    endDateConfirm(val) {
      this.endDateShow = false;
      this.endDate = FormatDate(val.getTime(), "YY/MM/DD");
      this.input.endTime =this.endDate;
    },
    changeIndex(val) {
      //console.log(this.selectIndex);
      this.selectIndex = val;
      this.input.timeType = val;
      this.startDate="";
      this.endDate="";
      this.input.startTime="";
      this.input.endTime="";

    },
    onSearch() {
      //console.log(this.input);
      var that = this;
      var _input = JSON.stringify(this.input);
      this.$store.commit({
          type:"setOrderDateFilter",
          input:_input
        })
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.date-tab-box {
  display: flex;
  align-items: center;
  padding: 15px 0;
  justify-content: space-evenly;
}
.date-tab-box .item {
  height: 32px;
  line-height: 32px;
  background: #fff;
  border-radius: 99px;
  font-size: 14px;
  color: #444;
  text-align: center;
  width: 60px;
}
.date-tab-box .item.active {
  background: #24a378 !important;
  color: #fff;
}
.date-range-box {
  background: #fff;
  padding: 15px;
}
.date-range-box .tit {
  font-size: 17px;
  color: #333;
  text-align: center;
  margin: 15px 0;
}
.date-range-select {
  display: flex;
  align-items: center;
}
.date-range-select .contact-word {
  font-size: 15px;
  color: #444;
  margin: 15px;
}
.date-field {
  border-bottom: 1px solid #ddd;
}
.delete-box {
  text-align: right;
  margin: 15px;
}
</style>
